import React from 'react';
import BottomAccordion from '../../../shared/bottom-accordion/content';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function Accordion(props) {
  let aboutThisPageMarkup = (
    <div>
      <i className="ui icon info circle mrls mrrnull text-size-xl fr mrbs" />
      <p>{htmlToReactParser.parse(xss(APP.LANGUAGE.ManageAllUsers.InfoPartOne))}</p>
      <p>{htmlToReactParser.parse(xss(APP.LANGUAGE.ManageAllUsers.InfoPartTwo))}</p>
    </div>
  );
  let options = [
    {
      title: APP.LANGUAGE.RightHandSidePanel.AboutThisPage,
      as: 'custom',
      content: aboutThisPageMarkup,
    },
  ];
  let activeIndexOfPage = window.localStorage.getItem(`allUsersActiveIndex-${props.userId}`);
  return (
    <BottomAccordion
      options={options}
      userId={props.userId}
      pagePrefix="allUsersActiveIndex"
      activeIndex={
        (!!activeIndexOfPage && JSON.parse(activeIndexOfPage)) || [
          options[options.length - 1].title.split(' ').join(''),
        ]
      }
    />
  );
}
